// extracted by mini-css-extract-plugin
export default {"settings-form":"aMIRZXpjc3wxhI8PT2tU"};